/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-records.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/utils.service';
import * as import10 from '../shared/content.service';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '@angular/common/src/location/location';
import * as import13 from '@angular/router/src/router';
import * as import14 from '@angular/core/src/metadata/view';
import * as import15 from '@angular/core/src/linker/component_factory';
import * as import16 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import17 from '../shared/searchable-contents.component.ngfactory';
import * as import18 from '../shared/search.service';
import * as import19 from '../shared/search-elasticsearch.service';
import * as import20 from '@angular/core/src/linker/template_ref';
import * as import21 from '@angular/common/src/directives/ng_switch';
import * as import22 from '../shared/searchable-contents.component';
import * as import23 from '../shared/loading-indicator.ngfactory';
import * as import24 from '../shared/loading-indicator';
import * as import25 from '../shared/search-filter.component.ngfactory';
import * as import26 from './search-results.component.ngfactory';
import * as import27 from '../shared/search-filter.component';
import * as import28 from './search-results.component';
export class Wrapper_ContentRecordsComponent {
  context:import0.ContentRecordsComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this.changed = false;
    this.context = new import0.ContentRecordsComponent(p0,p1,p2,p3,p4,p5);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentRecordsComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentRecordsComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _ContentRecordsComponent_0_4:Wrapper_ContentRecordsComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent_Host0,renderType_ContentRecordsComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentRecordsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._ContentRecordsComponent_0_4 = new Wrapper_ContentRecordsComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.UtilsService),this.parentInjector.get(import10.ContentService),this.parentInjector.get(import11.ActivatedRoute),this.parentInjector.get(import12.Location),this.parentInjector.get(import13.Router));
    this._appEl_0.initComponent(this._ContentRecordsComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._ContentRecordsComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ContentRecordsComponent) && (0 === requestNodeIndex))) { return this._ContentRecordsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentRecordsComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentRecordsComponent_0_4.context.ngAfterContentChecked(); }
    this._ContentRecordsComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentRecordsComponent_Host === (null as any))) { (renderType_ContentRecordsComponent_Host = viewUtils.createRenderComponentType('',0,import14.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentRecordsComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentRecordsComponentNgFactory:import15.ComponentFactory<import0.ContentRecordsComponent> = new import15.ComponentFactory<import0.ContentRecordsComponent>('ng-component',viewFactory_ContentRecordsComponent_Host0,import0.ContentRecordsComponent);
const styles_ContentRecordsComponent:any[] = ([] as any[]);
var renderType_ContentRecordsComponent:import2.RenderComponentType = (null as any);
class _View_ContentRecordsComponent0 extends import1.AppView<import0.ContentRecordsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _NgSwitch_12_3:import16.Wrapper_NgSwitch;
  _SearchableContentsComponent_12_4:import17.Wrapper_SearchableContentsComponent;
  _text_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _appEl_15:import3.AppElement;
  _TemplateRef_15_5:any;
  _NgSwitchCase_15_6:import16.Wrapper_NgSwitchCase;
  _text_16:any;
  _text_17:any;
  _anchor_18:any;
  /*private*/ _appEl_18:import3.AppElement;
  _TemplateRef_18_5:any;
  _NgSwitchCase_18_6:import16.Wrapper_NgSwitchCase;
  _text_19:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent0,renderType_ContentRecordsComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content-header'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'h1',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'Catalogue\n    ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'a',new import4.InlineArray2(2,'class','lLink'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n      ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'div',new import4.InlineArray2(2,'class','btn btn-default btn-sm'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'Nouveau',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_11 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray8(6,'class','container-fluid','context','record','searchable-contents',''),(null as any));
    this._NgSwitch_12_3 = new import16.Wrapper_NgSwitch();
    this._SearchableContentsComponent_12_4 = new import17.Wrapper_SearchableContentsComponent(this.parentInjector.get(import10.ContentService),this.parentInjector.get(import18.SearchService),this.parentInjector.get(import9.UtilsService),this.parentInjector.get(import11.ActivatedRoute),this.parentInjector.get(import13.Router),this.parentInjector.get(import19.ElasticSearchService));
    this._text_13 = this.renderer.createText(this._el_12,'\n\n  ',(null as any));
    this._text_14 = this.renderer.createText(this._el_12,'\n	',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._appEl_15 = new import3.AppElement(15,12,this,this._anchor_15);
    this._TemplateRef_15_5 = new import20.TemplateRef_(this._appEl_15,viewFactory_ContentRecordsComponent1);
    this._NgSwitchCase_15_6 = new import16.Wrapper_NgSwitchCase(this._appEl_15.vcRef,this._TemplateRef_15_5,this._NgSwitch_12_3.context);
    this._text_16 = this.renderer.createText(this._el_12,'\n\n  ',(null as any));
    this._text_17 = this.renderer.createText(this._el_12,'\n  ',(null as any));
    this._anchor_18 = this.renderer.createTemplateAnchor(this._el_12,(null as any));
    this._appEl_18 = new import3.AppElement(18,12,this,this._anchor_18);
    this._TemplateRef_18_5 = new import20.TemplateRef_(this._appEl_18,viewFactory_ContentRecordsComponent2);
    this._NgSwitchCase_18_6 = new import16.Wrapper_NgSwitchCase(this._appEl_18.vcRef,this._TemplateRef_18_5,this._NgSwitch_12_3.context);
    this._text_19 = this.renderer.createText(this._el_12,'\n\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._text_17,
      this._anchor_18,
      this._text_19
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import21.NgSwitchCase) && (15 === requestNodeIndex))) { return this._NgSwitchCase_15_6.context; }
    if (((token === import20.TemplateRef) && (18 === requestNodeIndex))) { return this._TemplateRef_18_5; }
    if (((token === import21.NgSwitchCase) && (18 === requestNodeIndex))) { return this._NgSwitchCase_18_6.context; }
    if (((token === import21.NgSwitch) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._NgSwitch_12_3.context; }
    if (((token === import22.SearchableContentsComponent) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._SearchableContentsComponent_12_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_12_0_0:any = this._SearchableContentsComponent_12_4.context.loading;
    this._NgSwitch_12_3.check_ngSwitch(currVal_12_0_0,throwOnChange,false);
    this._NgSwitch_12_3.detectChangesInInputProps(this,this._el_12,throwOnChange);
    const currVal_12_1_0:any = 'record';
    this._SearchableContentsComponent_12_4.check_context(currVal_12_1_0,throwOnChange,false);
    const currVal_12_1_1:any = this.context.pageSize;
    this._SearchableContentsComponent_12_4.check_pageSize(currVal_12_1_1,throwOnChange,false);
    const currVal_12_1_2:any = true;
    this._SearchableContentsComponent_12_4.check_noCache(currVal_12_1_2,throwOnChange,false);
    this._SearchableContentsComponent_12_4.detectChangesInInputProps(this,this._el_12,throwOnChange);
    const currVal_15_0_0:any = true;
    this._NgSwitchCase_15_6.check_ngSwitchCase(currVal_15_0_0,throwOnChange,false);
    this._NgSwitchCase_15_6.detectChangesInInputProps(this,this._anchor_15,throwOnChange);
    const currVal_18_0_0:any = false;
    this._NgSwitchCase_18_6.check_ngSwitchCase(currVal_18_0_0,throwOnChange,false);
    this._NgSwitchCase_18_6.detectChangesInInputProps(this,this._anchor_18,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSwitch_12_3.detectChangesInHostProps(this,this._el_12,throwOnChange);
    this._SearchableContentsComponent_12_4.detectChangesInHostProps(this,this._el_12,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.context.utils.lLink('admin/record/edit/0',this.context.currentLanguage)) !== false);
    return (true && pd_4_0);
  }
}
export function viewFactory_ContentRecordsComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentRecordsComponent> {
  if ((renderType_ContentRecordsComponent === (null as any))) { (renderType_ContentRecordsComponent = viewUtils.createRenderComponentType('',0,import14.ViewEncapsulation.None,styles_ContentRecordsComponent,{})); }
  return new _View_ContentRecordsComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  /*private*/ _appEl_2:import3.AppElement;
  _LoadingIndicator_2_4:import23.Wrapper_LoadingIndicator;
  _text_3:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent1,renderType_ContentRecordsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n	  ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'loading-indicator',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_2 = new import3.AppElement(2,0,this,this._el_2);
    var compView_2:any = import23.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(2),this._appEl_2);
    this._LoadingIndicator_2_4 = new import23.Wrapper_LoadingIndicator();
    this._appEl_2.initComponent(this._LoadingIndicator_2_4.context,([] as any[]),compView_2);
    compView_2.create(this._LoadingIndicator_2_4.context,([] as any[]),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n	',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.LoadingIndicator) && (2 === requestNodeIndex))) { return this._LoadingIndicator_2_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._LoadingIndicator_2_4.detectChangesInInputProps(this,this._el_2,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_2_4.detectChangesInHostProps(this,this._el_2,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordsComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordsComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  /*private*/ _appEl_6:import3.AppElement;
  _SearchFilterComponent_6_4:import25.Wrapper_SearchFilterComponent;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  /*private*/ _appEl_9:import3.AppElement;
  _SearchResultsComponent_9_4:import26.Wrapper_SearchResultsComponent;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordsComponent2,renderType_ContentRecordsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','content'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n      \n      ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'search-filters',new import4.InlineArray2(2,'title','Recherche'),(null as any));
    this._appEl_6 = new import3.AppElement(6,4,this,this._el_6);
    var compView_6:any = import25.viewFactory_SearchFilterComponent0(this.viewUtils,this.injector(6),this._appEl_6);
    this._SearchFilterComponent_6_4 = new import25.Wrapper_SearchFilterComponent(this.parent.parentInjector.get(import9.UtilsService),this.parent.parentInjector.get(import13.Router),this.parent.parentInjector.get(import11.ActivatedRoute),this.parent.parentInjector.get(import19.ElasticSearchService));
    this._appEl_6.initComponent(this._SearchFilterComponent_6_4.context,([] as any[]),compView_6);
    this._text_7 = this.renderer.createText((null as any),'\n      ',(null as any));
    compView_6.create(this._SearchFilterComponent_6_4.context,([] as any[]),(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n\n      ',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_4,'admin-search-results',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_9 = new import3.AppElement(9,4,this,this._el_9);
    var compView_9:any = import26.viewFactory_SearchResultsComponent0(this.viewUtils,this.injector(9),this._appEl_9);
    this._SearchResultsComponent_9_4 = new import26.Wrapper_SearchResultsComponent(this.parent.parentInjector.get(import8.ConfigService),this.parent.parentInjector.get(import10.ContentService),this.parent.parentInjector.get(import9.UtilsService),this.parent.parentInjector.get(import13.Router),this.parent.parentInjector.get(import11.ActivatedRoute));
    this._appEl_9.initComponent(this._SearchResultsComponent_9_4.context,([] as any[]),compView_9);
    this._text_10 = this.renderer.createText((null as any),'\n      ',(null as any));
    compView_9.create(this._SearchResultsComponent_9_4.context,([] as any[]),(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n\n    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._text_13 = this.renderer.createText(this._el_0,'\n\n  ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_9,'onSearch',this.eventHandler(this._handle_onSearch_9_0.bind(this)));
    const subscription_0:any = this._SearchResultsComponent_9_4.context.onSearch.subscribe(this.eventHandler(this._handle_onSearch_9_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13
    ]
    ,[disposable_0],[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.SearchFilterComponent) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 7)))) { return this._SearchFilterComponent_6_4.context; }
    if (((token === import28.SearchResultsComponent) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._SearchResultsComponent_9_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_6_0_0:any = (<_View_ContentRecordsComponent0>this.parent)._SearchableContentsComponent_12_4.context.esQuery;
    this._SearchFilterComponent_6_4.check_esQuery(currVal_6_0_0,throwOnChange,false);
    const currVal_6_0_1:any = (<_View_ContentRecordsComponent0>this.parent)._SearchableContentsComponent_12_4.context.esFilters;
    this._SearchFilterComponent_6_4.check_esFilters(currVal_6_0_1,throwOnChange,false);
    const currVal_6_0_2:any = 'Recherche';
    this._SearchFilterComponent_6_4.check_title(currVal_6_0_2,throwOnChange,false);
    this._SearchFilterComponent_6_4.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_9_0_0:any = (<_View_ContentRecordsComponent0>this.parent)._SearchableContentsComponent_12_4.context.esContents;
    this._SearchResultsComponent_9_4.check_esContents(currVal_9_0_0,throwOnChange,false);
    const currVal_9_0_1:any = (<_View_ContentRecordsComponent0>this.parent)._SearchableContentsComponent_12_4.context.dbContents;
    this._SearchResultsComponent_9_4.check_dbContents(currVal_9_0_1,throwOnChange,false);
    const currVal_9_0_2:any = (<_View_ContentRecordsComponent0>this.parent)._SearchableContentsComponent_12_4.context.pageSize;
    this._SearchResultsComponent_9_4.check_pageSize(currVal_9_0_2,throwOnChange,false);
    this._SearchResultsComponent_9_4.detectChangesInInputProps(this,this._el_9,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._SearchResultsComponent_9_4.context.ngAfterContentChecked(); }
    this._SearchFilterComponent_6_4.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._SearchResultsComponent_9_4.detectChangesInHostProps(this,this._el_9,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_onSearch_9_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_9_0:any = ((<any>(<_View_ContentRecordsComponent0>this.parent)._SearchableContentsComponent_12_4.context.searchCallBack($event)) !== false);
    return (true && pd_9_0);
  }
}
function viewFactory_ContentRecordsComponent2(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordsComponent2(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-records.component.ngfactory.ts